import { Toll } from "./toll";

export class TollGridViewItem {
    id?: string;
    siteName?: string;
    siteId?: string;
    companyName?: string;
    companyId?: string;
    date?: Date;
    plate?: string;
    isTruck?: boolean;
    isExceptionalConvoy? : boolean;
    quantity?: number;
    material?: string;
    materialId?: string;
    creationDate?: Date;
    isError? : boolean;
    billed?: boolean;
    toll?: Toll;
    constructor(tollGridViewItem?: TollGridViewItem) {
        this.id = tollGridViewItem?.id;
        this.siteName = tollGridViewItem?.siteName;
        this.siteId = tollGridViewItem?.siteId;
        this.companyName = tollGridViewItem?.companyName;
        this.companyId = tollGridViewItem?.companyId;
        this.date = tollGridViewItem?.date;
        this.isExceptionalConvoy = tollGridViewItem?.isExceptionalConvoy;
        this.plate = tollGridViewItem?.plate;
        this.isTruck = tollGridViewItem?.isTruck;
        this.quantity = tollGridViewItem?.quantity;
        this.material = tollGridViewItem?.material;
        this.materialId = tollGridViewItem?.materialId;
        this.creationDate = tollGridViewItem?.creationDate;
        this.toll = tollGridViewItem?.toll;
        this.isError = tollGridViewItem?.isError;
        this.billed = tollGridViewItem?.billed;
    }
}
